function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { j as p } from "./index.es33.js";
import { useMemo as te, useLayoutEffect as W, useEffect as d } from "react";
import { nanoid as re } from "nanoid";
import oe from "./index.es167.js";
import { clsx as ne } from "./index.es105.js";
import "./index.es133.js";
import { Portal as se } from "./index.es168.js";
import { checkInViewport as N } from "./index.es169.js";
import "./index.es134.js";
import { CSS_VARIABLES as S, DEFAULT_OFFSET as P, DELAY_BEFORE_SHOW_TOOLTIP as ce, OPPOSITE_POSITION_VARIANTS as ie } from "./index.es15.js";
import { defineOffset as fe } from "./index.es170.js";
import { setOffsetStyles as ue } from "./index.es171.js";
import { PositionVariants as b } from "./index.es172.js";
import { Tooltip as k } from "./index.es173.js";
import { IconWithTooltipFactory as le } from "./index.es174.js";
import { TextWithTooltipFactory as me } from "./index.es175.js";
import { CopyTooltip as ae } from "./index.es176.js";
import { useControlVisible as pe } from "./index.es177.js";
import { useTooltipRefs as de } from "./index.es178.js";
import V from "./index.es179.js";

var he = "--",
    f = function f(_ref) {
  var s = _ref.isAlwaysVisible,
      _ref$position = _ref.position,
      r = _ref$position === void 0 ? b.underCenter : _ref$position,
      h = _ref.alternativePosition,
      m = _ref.title,
      a = _ref.description,
      q = _ref.children,
      $ = _ref.tooltipRef,
      o = _ref.isVisibleDisabled,
      M = _ref.contentClassName,
      _ref$hideOnScroll = _ref.hideOnScroll,
      v = _ref$hideOnScroll === void 0 ? !0 : _ref$hideOnScroll,
      _ref$isResponsiveFrom = _ref.isResponsiveFromKey,
      I = _ref$isResponsiveFrom === void 0 ? !1 : _ref$isResponsiveFrom,
      _ref$showTooltipDelay = _ref.showTooltipDelay,
      z = _ref$showTooltipDelay === void 0 ? ce : _ref$showTooltipDelay,
      _ref$allowPreinstallN = _ref.allowPreinstallNode,
      U = _ref$allowPreinstallN === void 0 ? !1 : _ref$allowPreinstallN,
      X = _ref.onChangeVisible,
      x = _ref.computeCustomOffset;

  var _de = de({
    onChangeVisible: X,
    computeCustomOffset: x
  }),
      t = _de.childrenRef,
      _ = _de.visibilityRef,
      A = _de.computeCustomOffsetRef,
      Y = _de.onChangeVisibleRef,
      _pe = pe({
    onChangeVisibleRef: Y,
    isVisibleDisabled: o,
    hideOnScroll: v,
    isAlwaysVisible: s,
    visibilityRef: _,
    showTooltipDelay: z,
    allowPreinstallNode: U
  }),
      c = _pe.hideTooltip,
      E = _pe.showTooltip,
      C = _pe.changeBrowserTabVisibility,
      G = _pe.isVisibleTab,
      J = _pe.isVisibleTooltip,
      F = function F() {
    return C();
  },
      y = te(re, []),
      T = function T() {
    return document.getElementById(y);
  },
      O = function O() {
    return N({
      element: t.current,
      percentVisible: 10
    });
  },
      u = function u(e) {
    if (t.current && O()) {
      var n = A.current,
          _t$current$getBoundin = t.current.getBoundingClientRect(),
          i = _t$current$getBoundin.width,
          R = _t$current$getBoundin.height,
          Q = _t$current$getBoundin.top,
          Z = _t$current$getBoundin.left,
          K = _t$current$getBoundin.right,
          D = _t$current$getBoundin.bottom,
          j = fe({
        width: i,
        height: R,
        left: Z,
        right: K,
        top: Q,
        bottom: D
      }, e),
          B = n ? n(j) : j,
          l = T();

      if (l && B) {
        var ee = _toConsumableArray(l.style),
            H = _toConsumableArray(l.style).filter(function (w) {
          return w.includes(he);
        });

        ee.length !== H.length ? H.forEach(function (w) {
          return l.style.removeProperty(w);
        }) : l.removeAttribute("style"), ue({
          offset: B,
          element: l
        });
      }
    }
  },
      L = function L(e) {
    return h || ie[e];
  },
      g = function g() {
    return N({
      element: T(),
      percentVisible: 95
    });
  };

  return W(function () {
    A.current = x;
  }, [x]), W(function () {
    !m && !a && c();
  }, [m, a]), d(function () {
    var e = T();
    e && (e.style.setProperty(S.top, "".concat(P.top, "px")), e.style.setProperty(S.left, "".concat(P.left, "px")), e.style.setProperty(S.triangleOffset.transform, P.triangleOffset.transform));
  }, []), d(function () {
    !o && s && (m || a) && O() ? requestAnimationFrame(function () {
      E(function () {
        return u(r);
      });
    }) : c();
  }, [s, o, r, v]), d(function () {
    if (!o) {
      var e = new IntersectionObserver(function (i) {
        !i[0].isIntersecting && !g() && u(L(r));
      }, {
        threshold: [0.95]
      }),
          n = T();
      return n && e.observe(n), function () {
        e.disconnect();
      };
    }
  }, [m, a, r, h, o]), d(function () {
    if (!o && s) {
      var e = function e() {
        u(r), g() || u(L(r));
      },
          n = {
        withHide: oe(function () {
          requestAnimationFrame(function () {
            O() && E(e);
          });
        }, 200),
        withoutHide: function withoutHide() {
          requestAnimationFrame(function () {
            O() ? E(e) : c();
          });
        }
      },
          i = v ? n.withHide : n.withoutHide;

      return window.addEventListener("scroll", i, {
        passive: !0,
        capture: !0
      }), function () {
        window.removeEventListener("scroll", i, !0);
      };
    }
  }, [s, o, r, h, v]), d(function () {
    if (t.current && !s && !o) {
      var e = function e() {
        !I || G.current ? E(function () {
          return u(r);
        }, function () {
          return u(g() ? r : L(r));
        }) : C(!0);
      };

      return t.current.addEventListener("mouseenter", e), t.current.addEventListener("mouseleave", c), I && (t.current.addEventListener("focus", e, {
        passive: !0,
        capture: !0
      }), t.current.addEventListener("blur", c, {
        passive: !0,
        capture: !0
      }), document.addEventListener("visibilitychange", F)), function () {
        t.current && (t.current.removeEventListener("mouseenter", e), t.current.removeEventListener("mouseleave", c), I && (t.current.removeEventListener("focus", e, !0), t.current.removeEventListener("blur", c, !0), document.removeEventListener("visibilitychange", F)));
      };
    }
  }, [s, o, r, h]), p.jsxs("div", {
    className: ne("tooltip__wrapper", V.wrapper),
    "data-tooltip-id": y,
    children: [p.jsx("div", {
      ref: t,
      children: q
    }), !o && J && p.jsx(se, {
      styles: "position: fixed; z-index: var(--vds-layer-level-important);",
      children: p.jsx("div", {
        className: V.container,
        "data-tooltip-container-id": y,
        style: {
          visibility: "hidden",
          opacity: "0"
        },
        ref: _,
        children: p.jsx(k, {
          isAbsolute: !1,
          id: y,
          tooltipRef: $,
          description: a,
          title: m,
          className: M
        })
      })
    })]
  });
};

f.PositionVariants = b;
f.Tooltip = k;
f.Icon = le(f);
f.Text = me(f);
f.CopyText = ae;
export { f as Tooltip };